<template>
  <div class="h-screen flex overflow-hidden">
    <side-bar />
    <section class="flex-grow min-w-0 flex flex-col overflow-hidden">
      <TopBar v-if="$route.name !== 'admin.dashboard'" class="shrink-0" />
      <div class="flex-1 min-h-0 overflow-hidden flex flex-col">
        <router-view class="flex-1 flex flex-col min-h-0 min-w-0" />
      </div>
      <GlobalPlayer />
    </section>
  </div>
</template>
<script>
import SideBar from '@/components/app/dashboard/SideBar.vue';
import TopBar from '@/components/app/dashboard/TopBar.vue';
import GlobalPlayer from '@/components/player/GlobalPlayer.vue';

export default {
  components: {
    SideBar,
    TopBar,
    GlobalPlayer,
  },
  setup() {
    return {};
  },
};
</script>
